import React from 'react';
import MUIEditIcon from '@mui/icons-material/Edit';
import { SvgIconProps } from '@mui/material/SvgIcon';

const EditIcon = ({
  color = 'primary',
  ...rest
}: SvgIconProps) => (
  <MUIEditIcon
    color={color}
    {...rest}
  />
);

export default EditIcon;
